import React, { PropTypes } from 'react';
import TimelineItem from 'components/timeline/timelineItem';

class Timeline extends React.Component {
    render () {
        var self = this,
            items = self.props.items;

        return (
            <div className="timeline timeline-container">
                <div className="timeline-vertical-line"></div>

                <div className="timeline-list">
                    <div className="timeline-container timeline-list-item">
                        <div className="panel timeline-list-item-content-left">
                            <header className="panel-header panel-header-light">Location</header>
                        </div>
                        <div className="panel timeline-list-item-content-right">
                            <header className="panel-header panel-header-light">Activities</header>
                        </div>
                    </div>

                    { items.map((item, key) => {
                        return <TimelineItem key={ key } detail={ item } location={ self.props.location } />;
                    })}
                </div>
            </div>
        );
    }
};

export default Timeline;


// WEBPACK FOOTER //
// ./src/app/components/timeline/timeline.jsx